import { actions } from './actions';

type ActionType = (typeof actions)[keyof typeof actions];
interface UserState {
  id: string;
  name: string;
  role: string;
  email: string;
  avatar: string;
  authorized: boolean;
  loading: boolean;
  newPassword: boolean;
}

const initialState = {
  id: '',
  name: '',
  role: '',
  email: '',
  avatar: '',
  authorized: false,
  loading: false,
  newPassword: false,
};

export const userReducer = (
  state = initialState,
  action: { type: ActionType; payload: any },
): UserState => {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};
